<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            Sign In
          </div>
          <form role="form">
            <base-input
              class="input-group-alternative mb-3"
              placeholder="Email/Username"
              addon-left-icon="ni ni-email-83"
              v-model="model.email"
              :error="errors.email"
            />
            <base-input
              class="input-group-alternative"
              placeholder="Password"
              type="password"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="model.password"
              :error="errors.password"
            />
            <base-checkbox
              class="custom-control-alternative"
              v-model="model.remember"
            >
              <span class="text-muted">Remember me</span>
            </base-checkbox>
            <div class="text-center">
              <base-button
                type="primary"
                class="my-4"
                @click="login"
              >
                Sign in
              </base-button>
            </div>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <a href="#" class="text-light"><small>Forgot password?</small></a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {
      model: {
        email: '',
        password: '',
        remember: false,
      },
      errors: {
        email: '',
        password: '',
      },
    };
  },
  methods: {
    checkForErrors() {
      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key]) {
          this.errors[key] = '';
        }
      });
      if (this.model.email === '') {
        this.errors.email = 'This field is required';
      }
      if (this.model.password === '') {
        this.errors.password = 'This field is required';
      }
    },
    login() {
      this.checkForErrors();
      let isOk = true;
      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key]) {
          isOk = false;
        }
      });

      if (isOk) {
        this.axios
          .post('/auth/local', {
            identifier: this.model.email,
            password: this.model.password,
          })
          .then((response) => {
            console.log('User Profile: ', response.data.user);
            console.log('User Token: ', response.data.jwt);

            if (response.data.user.role.type === 'league_master') {
              // Let them in
              console.log(this.$store);
              this.$store.commit('setAuthToken', response.data.jwt);
              this.$store.commit('setUser', response.data.user);

              if (this.model.remember) {
                window.localStorage.setItem('northswing-token', response.data.jwt);
                window.localStorage.setItem('northswing-user', JSON.stringify(response.data.user));
              }

              this.$router.push('/');
            } else {
              // Not authorized
              this.$notify({
                verticalAlign: 'top',
                horizontalAlign: 'center',
                message: 'You must be a League Master to access this application.',
                type: 'danger',
              });
            }
          })
          .catch((error) => {
            console.log(error);
            this.$notify({
              verticalAlign: 'top',
              horizontalAlign: 'center',
              message: 'Incorrect Username or Password',
              type: 'danger',
            });
          });
      } else {
        this.$notify({
          verticalAlign: 'top',
          horizontalAlign: 'center',
          message: 'You are missing a required field.',
          type: 'warning',
        });
      }
    },
  },
};
</script>
<style>
</style>
